import { Component, Input, OnInit } from '@angular/core';
import { ChatAttachments } from '../../../services/chat-http.service';
import { GalleryImageService } from '../../../services/gallery-image.service';

@Component({
  selector: 'app-chat-message',
  templateUrl: './chat-message.component.html',
  styleUrls: ['./chat-message.component.scss']
})
export class ChatMessageComponent implements OnInit {

  @Input() images: ChatAttachments[];
  @Input() date: Date;
  @Input() title: string = 'ФИКС ПАЛМЕР';
  @Input() text: string;
  @Input() isRead: boolean;
  @Input() notAvatar: boolean;
  @Input() status: 'Approved' | 'Moderation' | 'Declined' | 'DateGroup';
  constructor(private galleryService: GalleryImageService) { }
  ngOnInit(): void {
  }

  openGallery(index: number) {
    this.galleryService.openChatGallery(this.images, index);
  }
}
